import './about-us.sass';
import { Container, Row, Col } from 'react-bootstrap';
import android_logo from '../../assets/images/android.png';
import ios_logo from '../../assets/images/ios.png';
import { Trans } from 'react-i18next';
import { useTranslation } from 'react-i18next';

const chunkArray = (array: any, size: any) => {
  const chunks = [];
  for (let i = 0; i < array.length; i += size) {
    chunks.push(array.slice(i, i + size));
  }
  return chunks;
};

function AboutUs() {
  const { t } = useTranslation();

  const data = [
    {
      title: t('whyNobel.0.title'),
      description: t('whyNobel.0.description'),
    },
    {
      title: t('whyNobel.1.title'),
      description: t('whyNobel.1.description'),
    },
    {
      title: t('whyNobel.2.title'),
      description: t('whyNobel.2.description'),
    },
    {
      title: t('whyNobel.3.title'),
      description: t('whyNobel.3.description'),
    },
    {
      title: t('whyNobel.4.title'),
      description: t('whyNobel.4.description'),
    },
    {
      title: t('whyNobel.5.title'),
      description: t('whyNobel.5.description'),
    },
  ];

  const app_section = [
    {
      title: t('customer_app'),
      logos: [
        {
          href: 'https://play.google.com/',
          src: android_logo,
          alt: 'android_logo',
        },
        {
          href: 'https://www.apple.com/pt/app-store/',
          src: ios_logo,
          alt: 'ios_logo',
        },
      ],
    },
    {
      title: t('provider_app'),
      logos: [
        {
          href: 'https://play.google.com/',
          src: android_logo,
          alt: 'android_logo',
        },
        {
          href: 'https://www.apple.com/pt/app-store/',
          src: ios_logo,
          alt: 'ios_logo',
        },
      ],
    },
  ];

  const rows = chunkArray(data, 3);
  return (
    <Container fluid>
      <Row className="about-container">
        <Col>
          <div className="intro-about">
            <h1 className="about-title">
              <Trans i18nKey="about_title" />
            </h1>
            <div className="about-paragraph">
              <p>
                <Trans i18nKey="AboutDescription" />
              </p>
              <p>
                <Trans i18nKey="MissionDescription" />
              </p>
            </div>
          </div>
        </Col>
      </Row>
      <Row className="why-container">
        <Col xs={12} className="text-center">
          <div className="why-header">
            <h1 className="why-title">
              <Trans i18nKey="why_nobel" />
            </h1>
            <h5 className="what-makes-us">
              <Trans i18nKey="what_makes_us" />
            </h5>
          </div>
        </Col>

        {rows.map((row, rowIndex) => (
          <Row key={rowIndex} className="points-group">
            {row.map((col: any, colIndex: any) => (
              <Col key={colIndex} className="points-item">
                <h5>{col.title}</h5>
                <p>{col.description}</p>
              </Col>
            ))}
          </Row>
        ))}
      </Row>
      <Row className="join-container">
        <Col>
          <div className="join_header">
            <h1 className="join_title">
              <Trans i18nKey="joinSection.title" />
            </h1>
            <p className="join-description">
              <Trans i18nKey="joinSection.description" />
            </p>
          </div>
          <hr className="mini-hr-horizontal" />
          <Col className="slogan">
            <p className="slogan-title">
              <Trans i18nKey="sloganSection.title" />
            </p>
            <Col>
              <h5 className="slogan-title2">
                <Trans i18nKey="sloganSection.subtitle" />
              </h5>
            </Col>
          </Col>
          <Row className="apps-row">
            {/* Customer App Column */}
            <Col className="apps-col">
              <h3>{app_section[0].title}</h3>
              <div className="logos">
                {app_section[0].logos.map((logo, index) => (
                  <a
                    href={logo.href}
                    key={index}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={logo.src} alt={logo.alt} className="logo-image" />
                  </a>
                ))}
              </div>
            </Col>

            {/* Vertical Divider */}
            <div className="mini-hr-vertical"></div>

            {/* Provider App Column */}
            <Col className="apps-col">
              <h3>{app_section[1].title}</h3>
              <div className="logos">
                {app_section[1].logos.map((logo, index) => (
                  <a
                    href={logo.href}
                    key={index}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={logo.src} alt={logo.alt} className="logo-image" />
                  </a>
                ))}
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
}

export { AboutUs };
